import ProtocolApiManager from './managers/ProtocolApiManager';

export default new ProtocolApiManager(`${process.env.APP_URL}/protocols`);



// WEBPACK FOOTER //
// ./src/common/protocol/api/protocol.js